export default __webpack_public_path__ + "static/media/arrowU.70047538.png";